<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { mapGetters } from 'vuex' 

import store from '@/store/index'

@Component({
    props: {
        dropdownYears: Array,
        userRole: String
    },
    computed: {
        ...mapGetters({
            fiscalYear: "getFiscalYear"
        })
    }
})

export default class YearsDropdown extends Vue {
    fiscalYearSelected = null
    role = this.userRole

    toggleYear(fiscalYearSelected) {
        if (store.state.role !== 'Teacher') {
            store.dispatch('admin/updateFiltersValues', fiscalYearSelected)
        }
        store.commit("updateFiscalYear", fiscalYearSelected)

        this.$ga.event({
            eventCategory: 'Select Fiscal Year (Observations)',
            eventAction: this.fiscalYearSelected,
            eventLabel: this.role
        })
    }
    mounted () {
        this.fiscalYearSelected = this.fiscalYear
    }
    uniqueYears (years) {
        return Array.from(new Set(years))
    }
}
</script>

<template>
    <el-select v-model="fiscalYearSelected" 
        @change="toggleYear"
        placeholder="Select A Year">
        <el-option
        v-for="year in uniqueYears(dropdownYears)"
        :key="year"
        :label="`${year - 1}-${year}`"
        :value="year">
        </el-option>
    </el-select>
</template>

<style>

</style>
